import MenuItem from '@mui/material/MenuItem';
import * as I from 'core/api/coreApiClient';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import { saveCommand } from 'core/redux/actions/command/commandActions';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import type React from 'react';
import { useDispatch } from 'react-redux';

function ItemPersist({
  item, buttonRef, onClose, selected,
}: ItemComponentProps) {
  const {
    id, title, httpVerb, onClickStart, onClick, active,
  } = item;

  const dispatch = useDispatch<AppThunkDispatch>();

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        component="button"
        role="button"
        data-e2e-dropdown-item={id}
        onClick={async (e: React.MouseEvent<HTMLElement>) => {
          if (onClickStart) onClickStart();
          if (httpVerb === I.HttpVerbConstants.POST) {
            const output = await dispatch(saveCommand(item, {})) as I.SectionResponse;
            if (onClick) onClick(item, output);
          }
          onClose(e, buttonRef);
        }}
        dense
        disabled={active === false}
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
      </MenuItem>
    </li>
  );
}
export default ItemPersist;
